<template>
  <div id="kiosk-welcome-page" class="row w-100 justify-content-center">
    <div class="col-12 col-md-8 text-center">
        <div class="d-inline-flex align-items-center justify-content-center mt-4 mb-4 kiosk-check-circle"
             style="width:80px; height:80px; border-radius:50%; background:var(--secondary-color);
                    box-shadow:0 6px 22px rgba(134,191,78,.3);">
          <i class="fa fas fa-check kiosk-check-icon" style="color:#fff; font-size:2rem;"></i>
        </div>
        <h1 class="mb-4">You're checked in, {{ firstName }}.</h1>
      <div class="text-muted" style="font-size:1.25rem;">
        Returning to search in <b style="color:var(--primary-color);">{{ countdown }}s</b>
      </div>
    </div>
  </div>
</template>

<style scoped>
#kiosk-welcome-page .kiosk-check-circle {
  animation: kiosk-pop .55s cubic-bezier(.34, 1.56, .64, 1) both;
}
#kiosk-welcome-page .kiosk-check-icon {
  display: inline-block;
  animation: kiosk-check-in .4s ease-out .25s both;
}
@keyframes kiosk-pop {
  0%   { transform: scale(0);    opacity: 0; }
  60%  { transform: scale(1.1);  opacity: 1; }
  100% { transform: scale(1);    opacity: 1; }
}
@keyframes kiosk-check-in {
  0%   { transform: scale(0) rotate(-45deg); opacity: 0; }
  100% { transform: scale(1) rotate(0);      opacity: 1; }
}
@media (max-width: 576px) {
  #kiosk-welcome-page h1 { font-size: 1.375rem !important; }
}
</style>

<script>
export default {
  name: 'KioskWelcome',
  props: {
    clientFullName: { type: String, default: '' }
  },
  data () {
    return { countdown: 8, timer: null }
  },
  computed: {
    firstName () { return (this.clientFullName || '').split(' ')[0] || 'there' }
  },
  created () {
    const self = this
    self.timer = setInterval(() => {
      self.countdown--
      if (self.countdown <= 0) { clearInterval(self.timer); self.$emit('reset') }
    }, 1000)
  },
  beforeDestroy () { if (this.timer) clearInterval(this.timer) }
}
</script>
